import { CustomersSearchComponent } from './../customers-search/customers-search.component';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { DataBankService } from 'src/app/services/DataBankService';
import { StockTrnHDModel } from 'src/app/models/StockTrnModel';
import { PatientAccModel } from 'src/app/models/PatientAccModel';
import { PatientAccService } from 'src/app/services/PAtientAccService';
import { CustomersModel } from 'src/app/models/customers-model';
import { CustomersService } from 'src/app/services/customers.service';

@Component({
  selector: 'app-patient-invoices',
  templateUrl: './patient-invoices.component.html',
  styleUrls: ['./patient-invoices.component.css']
})
export class PatientInvoicesComponent implements OnInit {
  w_type = '' ;
w_serial = '' ;
w_amount = 0 ;
w_date =formatDate(new Date(), 'yyyy-MM-dd', 'en');
w_patient = '' ;
trcln_supp_Namme = '';
w_desc = 0 ;
st_bank = '' ;
  FromDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  ToDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  InvoiceListList: PatientAccModel[] = [];
  constructor(public storage: LocalStorageService,
    private dialogref: MatDialog,
    public translate: TranslateService,
    public route: Router,
    public patientsSelectedData : DatabankModel,
    public dataBankService : DataBankService,
    public Cusotmer : CustomersModel,
    public CustomersService : CustomersService,
    public patinentaccservice :PatientAccService) { }

  ngOnInit(): void {
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  openDialogPatient(){
    if (this.storage.retrieve('stgCompCode') == '10' ){    const dialogRef = this.dialogref.open(CustomersSearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.w_patient = result.patientCode;
        this.RetrivePatient();

        dialogSubmitSubscription.unsubscribe();

      });}else {
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.w_patient = result.patientCode;
        this.RetrivePatient();

        dialogSubmitSubscription.unsubscribe();

      });
      }
  }
  RetrivePatient(){
    if ( this.storage.retrieve('stgCompCode') == '10') {this.CustomersService.getPatient(this.w_patient,this.storage.retrieve('stgcompCode')).subscribe((data: CustomersModel) => {
      this.trcln_supp_Namme = data.patientFName;
    })} else {
    this.dataBankService.getPatient(this.w_patient,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.trcln_supp_Namme = data.patientFName;
    })}

    this.patinentaccservice.GetPatientInvoice('21',this.FromDate,this.ToDate,this.w_patient, this.storage.retrieve('stgcompCode')).subscribe((data: PatientAccModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.InvoiceListList[i] = data[i];
        this.InvoiceListList[i].w_date = formatDate(data[i].w_date, 'yyyy-MM-dd', 'en')
        this.InvoiceListList[i].w_net = this.InvoiceListList[i].w_amount - this.InvoiceListList[i].w_desc;

     }
    })

  }
  SelectLine(pro : PatientAccModel){
    this.storage.store('stgSerial', pro.w_serial);
    //this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));

    //this.route.navigate(['report-vewier','CocReports/Invoice']);

  }
  PrintInvoices(){
    this.RetrivePatient();
    this.storage.store('stgFromDate', this.FromDate);
    this.storage.store('stgToDate', this.ToDate);
    this.storage.store('stgPatient', this.w_patient);

    this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
    this.route.navigate(['report-vewier', 'CocReports/SalesPatient']);

  }
}
